export class Mask {
  isDisplayed = false;
  isLoading = false;
  message: string = undefined;

  show(message?: string) {
    this.isDisplayed = true;
    this.message = message;
  }

  showLoading(message?: string) {
    this.isDisplayed = true;
    this.isLoading = true;
    this.message = message;
  }

  hide() {
    this.isDisplayed = false;
    this.isLoading = false;
    this.message = undefined;
  }
}

/*
 * Service mask
 */
angular.module('v6CoreModule').factory('mask', () => {
  return new Mask();
});
